import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'next-i18next';

import { ProfileContext } from '@spa/shared/contexts/profile';
import { Item, Separator, Welcome } from './styles';

const guestTabs = [
  { href: `${process.env.APP_URL}dashboard/bookings`, key: 'header:Your stays' },
  { href: `${process.env.APP_URL}dashboard/wishlist`, key: 'header:Favourites' }
];

const ApTabs = [{ href: `${process.env.AP_URL}bookings/requests`, key: 'header:Dashboard' }];

const AuthenticatedMenu = ({ isAccommodationProvider, hideTabs, guestName }) => {
  const { t } = useTranslation('header');

  const tabs = isAccommodationProvider ? ApTabs : guestTabs;
  const { profile } = useContext(ProfileContext);
  const { basic_info: { full_name: { first = t('header:User') } = {} } = {} } = profile || {};
  const firstName = guestName || first;

  return (
    <React.Fragment>
      <Welcome>
        {t('header:Hello')}, <span>{firstName}</span>
      </Welcome>
      {!hideTabs &&
        tabs.map(({ key, href }, index) => {
          const translation = t(key);

          return (
            <Item key={index}>
              <a href={href} title={translation}>
                {translation}
              </a>
            </Item>
          );
        })}
      <Separator />
    </React.Fragment>
  );
};

AuthenticatedMenu.propTypes = {
  isAccommodationProvider: PropTypes.bool,
  hideTabs: PropTypes.bool,
  guestName: PropTypes.bool
};

export default AuthenticatedMenu;
